import React, { useState } from "react";
import _ from "lodash";
import AnimatedSection from "./AnimatedSection";
import getEnvEndpoints from "../../../utils/endpoints";

const endpoints = getEnvEndpoints();

const HtmlInteractiveContent = ({ setExpanded, sections, title, icons }) => {
  const [opened, setOpened] = useState([]);

  const descriptions = title ? title.split("\n") : [];

  const isOpened = (id) => {
    return opened.includes(id);
  };

  const toggleSection = (id) => {
    opened.includes(id)
      ? setOpened(opened.filter((i) => i !== id))
      : setOpened([...opened, id]);
  };

  const getIconSrc = (title) => {
    if (!title) {
      return "";
    }

    const iconFile = _.find(icons, { title });
    return iconFile
      ? iconFile.filePath
        ? iconFile.filePath
        : endpoints.baseContentUrl + iconFile.relativePath
      : "";
  };

  return (
    <div>
      <div className="mt-5">
        {title && (
          <>
            {descriptions.map((d, i) => (
              <div className="my-4" key={i}>
                <p className="text-black text-lg sm:text-xl agrandir leading-tight">
                  {d}
                </p>
              </div>
            ))}
          </>
        )}

        {sections &&
          sections.map((section) => (
            <div key={section.id}>
              <div
                onClick={() => toggleSection(section.id)}
                className="flex justify-start border-t py-5 items-center cursor-pointer"
              >
                {section.content && (
                  <div>
                    <img
                      src="/images/arrow.svg"
                      alt="arrow"
                      className="mr-5"
                      style={{
                        minWidth: "1rem",
                        minHeight: "1rem",
                        transform: isOpened(section.id) ? "rotate(90deg)" : "",
                        transition: "all .3s ease",
                      }}
                    />
                  </div>
                )}
                {section.icon && (
                  <img
                    src={getIconSrc(section.icon)}
                    className="mr-3"
                    alt="icon"
                    style={{
                      minWidth: "2.5rem",
                      minHeight: "2.5rem",
                      width: "2.5rem",
                      height: "2.5rem",
                    }}
                  />
                )}
                <div className="agrandir text-purple-800 font-bold text-lg sm:text-xl">
                  {section.title}
                  {section.subtitle && (
                    <>
                      <br />
                      <p className="pt-2 text-black font-normal text-md sm:text-lg">
                        {section.subtitle}
                      </p>
                    </>
                  )}
                </div>
              </div>

              <AnimatedSection
                isOpened={isOpened(section.id)}
                sectionContent={section.content}
              />
            </div>
          ))}
      </div>

      <div
        onClick={() => setExpanded(false)}
        className="bg-orange-500 rounded-lg px-3 py-2 text-center cursor-pointer mt-5 my-3 mx-auto"
        style={{ width: "120px" }}
      >
        <h5 className="text-white text-xs lg:text-sm font-bold">Close</h5>
      </div>
    </div>
  );
};

export default HtmlInteractiveContent;
